import CountryUtil from "../uidispatcherapi/CountryUtil";
import { Link } from "../datatypes/ConfiguredLinks";

export function getLinksCustomerNavigation(): Link[] {
    return CountryUtil.getOptionalConfig().customerPortalLinks;
}

export function getLinksLoginPopup(): Link[] {
    return CountryUtil.getOptionalConfig().loginPopupLinks;
}
